/**
 * @generated SignedSource<<abc6b5c16a0a35987451dcca614c0c2e>>
 * @relayHash 42f0b8f377bee315d4d5e0bd8fea509b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8744e6ea60880265fc0d0c08bbd0517e2f1c5cb760dc27ec635314b8b80c0d8b

import type { ConcreteRequest } from 'relay-runtime';
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type HelpCenterNavigationBarBorderType = "ALL_BORDER" | "BOTTOM_BORDER" | "NO_BORDER" | "%future added value";
export type HelpCenterNavigationBarPositionType = "FIXED" | "FLOATING" | "%future added value";
export type HelpCenterType = "ADVANCED" | "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "UNIFIED" | "%future added value";
export type hubQuery$variables = {
  cloudId: string;
  hubAri: string;
  isDraft?: boolean | null;
  operationType?: HelpCenterMediaConfigOperationType | null;
  pageAri: string;
  rovoConfigFromKosh?: boolean | null;
};
export type hubQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly helpCenterBranding: {
        readonly navigationBar: {
          readonly backgroundColor: string | null;
          readonly borderColor: string | null;
          readonly borderType: HelpCenterNavigationBarBorderType | null;
          readonly cornerRadius: number | null;
          readonly padding: boolean | null;
          readonly positionType: HelpCenterNavigationBarPositionType | null;
          readonly textColor: string | null;
        } | null;
      } | null;
      readonly name: {
        readonly default: string;
      } | null;
      readonly pages: ReadonlyArray<{
        readonly id: string;
        readonly name: {
          readonly default: string;
        } | null;
        readonly pageLayout: {
          readonly layoutAdf: {
            readonly content: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly content: string | null;
                } | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        readonly rovoConfig?: {
          readonly agentId: string | null;
          readonly isCustomAgentsAvailable: boolean | null;
          readonly isRovoEnabled: boolean | null;
          readonly widgetContainerAri: string | null;
        } | null;
      } | null> | null;
      readonly type: HelpCenterType | null;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly pageMediaConfig: {
      readonly asapIssuer: string;
      readonly mediaCollectionName: string;
      readonly mediaToken: string;
      readonly mediaUrl: string;
    };
  } | null;
};
export type hubQuery = {
  response: hubQuery$data;
  variables: hubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "rovoConfigFromKosh"
},
v6 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "pageAri"
  },
  {
    "kind": "Variable",
    "name": "isDraft",
    "variableName": "isDraft"
  },
  {
    "kind": "Variable",
    "name": "operationType",
    "variableName": "operationType"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "asapIssuer"
},
v9 = {
  "kind": "ScalarField",
  "name": "mediaCollectionName"
},
v10 = {
  "kind": "ScalarField",
  "name": "mediaToken"
},
v11 = {
  "kind": "ScalarField",
  "name": "mediaUrl"
},
v12 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "hubAri"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "concreteType": "HelpCenterName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": (v14/*: any*/)
    },
    {
      "concreteType": "HelpCenterBranding",
      "kind": "LinkedField",
      "name": "helpCenterBranding",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterNavigationBar",
          "kind": "LinkedField",
          "name": "navigationBar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "backgroundColor"
            },
            {
              "kind": "ScalarField",
              "name": "borderColor"
            },
            {
              "kind": "ScalarField",
              "name": "borderType"
            },
            {
              "kind": "ScalarField",
              "name": "cornerRadius"
            },
            {
              "kind": "ScalarField",
              "name": "padding"
            },
            {
              "kind": "ScalarField",
              "name": "positionType"
            },
            {
              "kind": "ScalarField",
              "name": "textColor"
            }
          ]
        }
      ]
    },
    {
      "args": [
        {
          "fields": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "ids.0",
                  "variableName": "pageAri"
                }
              ],
              "kind": "ListValue",
              "name": "ids"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "HelpCenterPage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v15/*: any*/),
        {
          "concreteType": "HelpCenterPageName",
          "kind": "LinkedField",
          "name": "name",
          "plural": false,
          "selections": (v14/*: any*/)
        },
        {
          "condition": "rovoConfigFromKosh",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "HelpCenterPageRovoConfig",
              "kind": "LinkedField",
              "name": "rovoConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "isCustomAgentsAvailable"
                },
                {
                  "kind": "ScalarField",
                  "name": "isRovoEnabled"
                },
                {
                  "kind": "ScalarField",
                  "name": "agentId"
                },
                {
                  "kind": "ScalarField",
                  "name": "widgetContainerAri"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "HelpCenterPageLayout",
          "kind": "LinkedField",
          "name": "pageLayout",
          "plural": false,
          "selections": [
            {
              "concreteType": "HelpCenterLayoutAdf",
              "kind": "LinkedField",
              "name": "layoutAdf",
              "plural": false,
              "selections": [
                {
                  "concreteType": "HelpCenterLayoutAdfContentConnection",
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "HelpCenterLayoutAdfContentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "HelpCenterLayoutAdfContent",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "content"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "pageMediaConfig",
              "args": (v7/*: any*/),
              "concreteType": "HelpCenterMediaConfig",
              "kind": "LinkedField",
              "name": "hubMediaConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v8/*: any*/),
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": (v9/*: any*/),
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": (v10/*: any*/),
                  "action": "THROW"
                },
                {
                  "kind": "RequiredField",
                  "field": (v11/*: any*/),
                  "action": "THROW"
                }
              ]
            },
            "action": "THROW"
          },
          {
            "args": (v12/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": "pageMediaConfig",
            "args": (v7/*: any*/),
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ]
          },
          {
            "args": (v12/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v15/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8744e6ea60880265fc0d0c08bbd0517e2f1c5cb760dc27ec635314b8b80c0d8b",
    "metadata": {},
    "name": "hubQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5e59cd05e6bafe2ced1b201960911b05";

export default node;
